import { render, staticRenderFns } from "./PurchaseMarkCreate.vue?vue&type=template&id=8204f250"
import script from "./PurchaseMarkCreate.vue?vue&type=script&lang=js"
export * from "./PurchaseMarkCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports